define('navigation',['require','exports','module','fukit','jquery'],function(require, exports, module) {
  const ROLES = require('fukit').Roles;
  const JQuery = require('jquery');

  const token = 'Bearer ' + localStorage.getItem('fk_accessToken');
  const PRODUCT_NAME_HEADER = 'Product-Name';
  const COI_VALUE = 'COI';

  const headers = {
    Authorization: token,
    X_IDP_NEW_LOGIN_HEADER: true,
    PRODUCT_NAME_HEADER: COI_VALUE
  };

  const tenantId = localStorage.getItem('tenantId');
  const tenantInfoUrl = '/api/v2/tenant/tenant/' + tenantId + '/product/findFirstByName?name=COI';

  var productNewCoiUi = false;

  if (tenantId !== null) {
    JQuery.ajax({
      url: tenantInfoUrl,
      mode: 'cors',
      headers: headers,
      method: 'GET',
      async: false,
      contentType: 'application/json',
    })
      .done(function(data) {
        productNewCoiUi = data && data.productNewCoiUi;
        localStorage.setItem('productNewCoiUi', productNewCoiUi.toString());
      })
      .fail(function(jqXHR, textStatus, errorThrown) {
        console.error('Ajax request failed:', errorThrown);
      });
  }

  if (localStorage.getItem('productNewCoiUi') === 'true' || localStorage.getItem('productNewCoiUiValue') === 'true') {
    productNewCoiUi = true;
  }

  var linkOrRoute = 'route';
  if( productNewCoiUi === true) {
    linkOrRoute = 'link';
  }

  module.exports = {
    // 'route' property is for internal app links, and 'link' is for external links in the menu.
    items: [
      {
        text: 'Dashboard',
        [linkOrRoute]: productNewCoiUi === true ? '/coi-react/dashboard' : 'default',
        visibleOnlyWhen: {
          roles: [ROLES.COI_WEB_ACCESS],
        },
        onclick: function() {
          if (productNewCoiUi) {
            window.location.href = '/coi-react/dashboard';
          }
        },
      },
      {
        text: 'Disclosures',
        [linkOrRoute]:
          productNewCoiUi === true ? '/coi-react/disclosure/list' : 'disclosure:list',
        visibleOnlyWhen: {
          // Only COI Admin has this role and reviewer doesn't
          roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
        },
        onclick: function() {
          if (productNewCoiUi) {
            window.location.href = '/coi-react/disclosure/list';
          }
        },
      },
      {
        text: 'Reporting',
        [linkOrRoute]: productNewCoiUi === true ? '/coi-react/reporting' : 'reporting',
        visibleOnlyWhen: {
          roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
        },
        onclick: function() {
          if (productNewCoiUi) {
            window.location.href = '/coi-react/reporting';
          }
        },
      },
      {
        text: 'More',
        visibleOnlyWhen: {
          // roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
        },
        children: [
          {
            text: 'Settings',
            header: true,
            visibleOnlyWhen: {
              roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
            },
          },
          {
            text: 'Form Manager',
            route: 'template:list',
            visibleOnlyWhen: {
              roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
            },
          },
          {
            text: 'Disclosure Campaign Manager',
            [linkOrRoute]:
              productNewCoiUi === true ? '/coi-react/settings/campaignManager' : 'campaign:manager',
            visibleOnlyWhen: {
              roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
            },
            onclick: function() {
              if (productNewCoiUi) {
                window.location.href = '/coi-react/settings/campaignManager';
              }
            },
          },
          {
            text: 'Ad Hoc Disclosures',
            [linkOrRoute]:
              productNewCoiUi === true ? '/coi-react/disclosure/send' : 'disclosure:send',
            visibleOnlyWhen: {
              roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
            },
            onclick: function() {
              if (productNewCoiUi) {
                window.location.href = '/coi-react/disclosure/send';
              }
            },
          },
          {
            text: 'Automate Approvals & Assignments',
            [linkOrRoute]:
              productNewCoiUi === true ? '/coi-react/disclosure/approvals' : 'disclosure:approvals',
            visibleOnlyWhen: {
              roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS],
            },
            onclick: function() {
              if (productNewCoiUi) {
                window.location.href = '/coi-react/disclosure/approvals';
              }
            },
          },
          {
            text: 'Disclosure Resolution Setting',
            [linkOrRoute]:
              productNewCoiUi === true ? '/coi-react/disclosure/resolution' : 'settings:resolution',
            // TODO: Lock this down to the appropriate role
            visibleOnlyWhen: {
              roles: [ROLES.COI_SETTINGS_UPDATE],
            },
            onclick: function() {
              if (productNewCoiUi) {
                window.location.href = '/coi-react/disclosure/resolution';
              }
            },
          },
        ],
      },
    ],
  };
});

